export default "https://assets.egbcdn.net/assets/packs/_/images/p2p/bank-logotype-576c8c1bd1ff2368d2796860a42007f3.svg";